import { render, staticRenderFns } from "./batchTasks.vue?vue&type=template&id=374c8db6&scoped=true"
import script from "./batchTasks.vue?vue&type=script&lang=js"
export * from "./batchTasks.vue?vue&type=script&lang=js"
import style0 from "./batchTasks.vue?vue&type=style&index=0&id=374c8db6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374c8db6",
  null
  
)

export default component.exports